import React, { Component, PropTypes } from 'react';
import getClassNames from 'classnames';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { TextField, FlatButton } from 'material-ui';
import Card from '../tc-ui/card';
import Icon from '../tc-ui/icon';
import AddItemCard from './add-item-card';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

class Description extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showResults: false,
      moreText: false,
      labelState: true,
    };
  }

  componentDidMount() {
    if (!this.refs.about) return;
    this.setShowAll();
  }

  setShowAll = () => {
    const aboutHeight = findDOMNode(this.refs.about).offsetHeight;
    if (aboutHeight > 126) {
      return this.setState({
        showResults: true,
        moreText: true,
        labelState: true,
      });
    }
    return this.setState({
      showResults: false,
      labelState: false,
    });
  };

  _addClass = (e) => {
    e.preventDefault();
    this.setState({
      showResults: !this.state.showResults,
      moreText: !this.state.moreText,
    });
  };

  _editDescription = () => {
    this.props.inlineEditField('description', { isRequired: true, type: 'text' });
  };

  render() {
    const { profileToShow, field, editMode, editValue, routeName } = this.props;
    const description = profileToShow.description;
    const title = routeName === 'product' ? 'About This Product' : 'Description';

    if (editMode) {
      return (
        <div className="location-data">
          <Card
            className="profile-card"
            title="Edit Description"
            subtitle=""
          >
            <TextField
              multiLine
              id="descriptionTF"
              placeholder="Enter here..."
              style={{ width: '100%' }}
              onChange={({ target: { value } }) => this.props.sendEditToReducer({
                value,
              })}
              defaultValue={editValue}
            />
            <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
              <FlatButton
                style={{ marginRight: '8px' }}
                label="Cancel"
                primary
                onClick={this.props.clearEditState}
              />
              <FlatButton
                style={{ marginRight: '8px' }}
                label="Save"
                secondary
                disabled={isNilOrEmpty(editValue)}
                onClick={() => {
                  const options = {
                    updateField: field,
                    updateBody: editValue,
                  };
                  return this.props._saveField(options);
                }}
              />
            </div>
          </Card>
        </div>
      );
    }
    const classes = getClassNames('l-paper-right-info profile-description-paragraph', this.props.className, {
      'short-info': this.state.showResults,
    });

    const label = this.state.moreText ? '+ More' : null;
    const more = this.state.labelState ? label : null;
    let gradient;
    if (this.state.moreText) gradient = <div className="cardGradient" />;

    let descriptionNode;
    let addItemNode;
    let titleBarExtra;
    if (description) {
      if (this.props.isEditable) {
        titleBarExtra = (
          <div className="profile-edit" onClick={this._editDescription}>
            <Icon className="tc-icon-mode_edit profile-edit-icon"/>
            &nbsp;EDIT
           </div>
        );
      }
      descriptionNode = (
        <Card
          className="profile-card"
          title={title}
          companyData="companyData"
          subtitle=""
          titleBarExtra={titleBarExtra}
        >
          <div className={classes} style={{ whiteSpace: 'pre-wrap' }} ref="about">
            {description}
          </div>
           {gradient}
         <a href="#" className="load-more" onClick={this._addClass}> {more} </a>
        </Card>
      );
    } else if (this.props.isEditable) {
      addItemNode = <AddItemCard onClick={this._editDescription} text="Add A Description"/>;
    }
    return (
      <div className={this.props.className} id="profile-description">
        {descriptionNode}
        {addItemNode}
      </div>
    );
  }
}

Description.propTypes = {
  isEditable: PropTypes.bool,
  className: PropTypes.string,
  profileToShow: PropTypes.object,
  routeName: PropTypes.string,
  user: PropTypes.object,
  inlineEditField: PropTypes.func,
  sendEditToReducer: PropTypes.func,
  editValue: PropTypes.any,
  field: PropTypes.string,
  editMode: PropTypes.bool,
  clearEditState: PropTypes.func,
  _saveField: PropTypes.func,
};

const mapStateToProps = ({ editFieldModal }) => ({
  field: editFieldModal.get('field'),
  editMode: editFieldModal.get('field') === 'description',
  editValue: editFieldModal.toJS().value || '',
});

export default connect(mapStateToProps)(Description);



// WEBPACK FOOTER //
// ./src/app/components/profile/company-description.jsx